<script setup>
import { SlidersHorizontalIcon } from 'lucide-vue-next'
</script>

<template>
  <SlidersHorizontalIcon />
</template>